import { Component, Inject, Input, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface DialogData {
  question: string;
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmValue?: boolean | string;
  cancelValue?: boolean | string;
  secondaryActionLabel?: string;
  secondaryActionValue?: boolean | string;
}

@Component({
  selector: "app-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
  styleUrls: ["./confirmation-dialog.component.scss"],
  standalone: false
})
export class ConfirmationDialogComponent implements OnInit {
  @Input() question = "";

  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit() {}

  public get titleKey(): string {
    return this.data?.title || "COMMON.CONFIRMATION";
  }

  public get confirmLabelKey(): string {
    return this.data?.confirmLabel || "COMMON.YES";
  }

  public get cancelLabelKey(): string {
    return this.data?.cancelLabel || "COMMON.NO";
  }

  public get hasSecondaryAction(): boolean {
    return !!this.data?.secondaryActionLabel;
  }

  public confirm(): void {
    this.dialogRef.close(this.data?.confirmValue ?? true);
  }

  public cancel(): void {
    this.dialogRef.close(this.data?.cancelValue ?? false);
  }

  public secondaryAction(): void {
    this.dialogRef.close(this.data?.secondaryActionValue ?? false);
  }
}
